var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit16PxFlipped(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1247 10.311L14.9691 13.9555C14.9982 14.0887 14.9972 14.2268 14.9662 14.3595C14.9351 14.4923 14.8748 14.6165 14.7896 14.723C14.7044 14.8295 14.5965 14.9156 14.4738 14.975C14.351 15.0345 14.2166 15.0658 14.0802 15.0666C14.0167 15.073 13.9526 15.073 13.8891 15.0666L10.2224 14.2222L3.18244 7.20882L7.11132 3.28882L14.1247 10.311Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.968902 3.69778L3.59112 1.07556C3.76352 0.904029 3.99682 0.807739 4.24001 0.807739C4.48321 0.807739 4.7165 0.904029 4.8889 1.07556L6.34668 2.53333L2.42224 6.45778L0.964456 5C0.879146 4.91426 0.811581 4.81253 0.765626 4.70065C0.719671 4.58877 0.69623 4.46892 0.696642 4.34797C0.697055 4.22701 0.721314 4.10733 0.768032 3.99576C0.814749 3.8842 0.883008 3.78294 0.968902 3.69778Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit16PxFlipped);
export default __webpack_public_path__ + "static/media/edit-16px-flipped.abe3b7cdde1d589cd4f52a45cbdbc42d.svg";
export { ForwardRef as ReactComponent };